/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { PageIcon, UserIcon } from "src/components/Search/Hits/Icons";

export const HitIcon = ({ type }: { type: string }) => {
  switch (type) {
    case "page":
      return <PageIcon />;
    case "user":
      return <UserIcon />;
    default:
      return <></>;
  }
};
